export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9546.49643399.jpg";